import { LocationNumbersStoreModule } from "../../../types/LocationNumbers"

const state = {
  agencyTwilio: {
    id: '',
    accountSid: '',
    companyId: '',
    traceId: '',
  },
  callerIDs: [],
  defaultOutboundNumber: '',
  loading: false,
  locationId: '',
  locationTwilio: {},
  mapPhoneNumberSID: {},
  modalLoading: false,
  numberPoolIDs: [],
  numberPools: [],
  numberPoolsIdIndexLookup: {},
  phoneNumbers: [],
  phoneNumbersPaginated: {},
  phoneNumbersIsUnderGHL: false,
  linkedNumbers: [],
  phoneNumbersSIDIndexLookup: {},
  phoneNumbersA2PLookup: {},
  renderedRecordsCount: 0,
  stripe: {},
  totalNumberPools: 0,
  totalPhoneNumbers: 0,
  totalVerifiedCallerIDs: 0,
  tollFreeStatus: {},
  tollFreeStatusTracker: "",
  table: {
    searchText: '',
    currentPage: 1,
    totalPages: 0,
    limit: 10,
  },
  a2pComplianceStatus: '',
  isA2PRestrictedByCompany: null,
  phoneNumbersSID: {},
  account3DSInfo: null,
  customerPayment: null,
  RCBundleList: {},
  RCAddressList: [],
} as LocationNumbersStoreModule

export default state
